import React from 'react';
import MarkdownModal from '../common/MarkdownModal';

interface UpcomingFeaturesModalProps {
  open: boolean;
  onClose: () => void;
}

const UpcomingFeaturesModal: React.FC<UpcomingFeaturesModalProps> = ({ open, onClose }) => {
  return (
    <MarkdownModal
      open={open}
      onClose={onClose}
      title=""
      markdownKey="UPCOMING_FEATURES" 
    />
  );
};

export default UpcomingFeaturesModal;
